import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "header-boxes"
}
const _hoisted_3 = { class: "kpi white-box" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "row header header--sticky" }
const _hoisted_8 = { class: "header-cell cell cell--align-center cell--invoice-number" }
const _hoisted_9 = { class: "header-cell cell cell--align-center cell--invoice-period" }
const _hoisted_10 = { class: "header-cell cell cell--align-center cell--invoice-date" }
const _hoisted_11 = { class: "header-cell cell cell--invoice-project" }
const _hoisted_12 = { class: "header-cell cell cell--invoice-company" }
const _hoisted_13 = { class: "header-cell cell cell--align-center cell--invoice-net-total" }
const _hoisted_14 = { class: "header-cell cell cell--align-center cell--invoice-total" }
const _hoisted_15 = { class: "header-cell cell cell--align-center cell--invoice-balance" }
const _hoisted_16 = { class: "header-cell cell cell--align-center cell--invoice-due-date" }
const _hoisted_17 = { class: "cell cell--invoice-number cell--align-center" }
const _hoisted_18 = { class: "cell cell--invoice-period cell--align-center" }
const _hoisted_19 = { class: "cell cell--invoice-date cell--align-center" }
const _hoisted_20 = { class: "cell cell--invoice-project" }
const _hoisted_21 = { class: "cell cell--invoice-company" }
const _hoisted_22 = { class: "cell cell--invoice-net-total cell--align-end" }
const _hoisted_23 = { class: "cell cell--invoice-total cell--align-end" }
const _hoisted_24 = { class: "cell cell--invoice-balance cell--align-end" }
const _hoisted_25 = { class: "cell cell--invoice-due-date cell--align-center" }
const _hoisted_26 = {
  key: 1,
  class: "cell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_OnClickOutside = _resolveComponent("OnClickOutside")!
  const _component_DropDownItem = _resolveComponent("DropDownItem")!
  const _component_DropDownMenu = _resolveComponent("DropDownMenu")!
  const _component_TileDashboard = _resolveComponent("TileDashboard")!
  const _component_PaymentModal = _resolveComponent("PaymentModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TileDashboard, {
      loading: _ctx.loading ? _ctx.t('invoices.loading') : undefined,
      "empty-space": !_ctx.hasInvoices ? _ctx.t('invoices.emptySpace') : undefined
    }, {
      default: _withCtx(() => [
        (_ctx.hasInvoices)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.totalAmountDue > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t("labels.invoices.totalAmountDue")), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.formatPrice(_ctx.totalAmountDue)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("labels.invoices.invoiceNumber")), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t("labels.invoices.period")), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t("labels.invoices.date")), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t("labels.invoices.project")), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t("labels.invoices.company")), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t("labels.invoices.netTotal")), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t("labels.invoices.total")), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t("labels.invoices.balance")), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t("labels.invoices.dueDate")), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header-cell cell cell--actions" }, null, -1))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: invoice.id,
                    class: "row row__inner"
                  }, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(invoice.invoiceNumber), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(invoice.linkedResource
                ? _ctx.formatOrderDate(invoice.linkedResource)
                : "-"), 1),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.dayjs(invoice.date).format("DD/MM/YYYY")), 1),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(invoice.project.name), 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(invoice.company.name), 1),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatPrice(invoice.netTotal)), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatPrice(invoice.total)), 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.formatPrice(invoice.balance)), 1),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.dayjs(invoice.dueDate).format("DD/MM/YYYY")), 1),
                    _createElementVNode("div", {
                      class: "cell cell--actions",
                      ref_for: true,
                      ref: (el) => _ctx.getRef(invoice.id, el)
                    }, [
                      (
                invoice.balance > 0 &&
                invoice.status !== _ctx.InvoiceStatusAsEnum.CANCELED
              )
                        ? (_openBlock(), _createBlock(_component_ButtonIcon, {
                            key: 0,
                            label: _ctx.t('buttons.invoices.pay'),
                            "icon-name": "material-symbols:qr-code-2",
                            onClick: _withModifiers(($event: any) => (_ctx.setInvoiceToPay(invoice)), ["prevent"])
                          }, null, 8, ["label", "onClick"]))
                        : (invoice.status === _ctx.InvoiceStatusAsEnum.CANCELED)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.t(`statusLabels.${_ctx.InvoiceStatusAsEnum.CANCELED}`)), 1))
                          : _createCommentVNode("", true),
                      _createVNode(_component_OnClickOutside, { onTrigger: _ctx.closeDropdown }, {
                        default: _withCtx(() => [
                          _createVNode(_component_IconButton, {
                            onClick: () => _ctx.handleInvoiceClick(invoice.id),
                            iconName: "bi:cloud-download"
                          }, null, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["onTrigger"]),
                      (_ctx.isDropdownActive(invoice.id))
                        ? (_openBlock(), _createBlock(_component_DropDownMenu, {
                            key: 2,
                            reference: _ctx.references[invoice.id]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DropDownItem, {
                                label: _ctx.t('dropDownMenu.download.invoice'),
                                iconName: "akar-icons:download",
                                href: `${_ctx.backEndUri}/documents/invoice/${invoice.id}`,
                                target: "_blank"
                              }, null, 8, ["label", "href"]),
                              (invoice.type === 'delta')
                                ? (_openBlock(), _createBlock(_component_DropDownItem, {
                                    key: 0,
                                    label: _ctx.t('dropDownMenu.download.timesheets'),
                                    iconName: "akar-icons:download",
                                    href: `${_ctx.backEndUri}/documents/documents/reports/draft-invoice/${invoice.linkedResource?.id}`,
                                    target: "_blank"
                                  }, null, 8, ["label", "href"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["reference"]))
                        : _createCommentVNode("", true)
                    ], 512)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading", "empty-space"]),
    (_ctx.invoiceToPay && _ctx.isPaymentModalVisible)
      ? (_openBlock(), _createBlock(_component_PaymentModal, {
          key: 0,
          invoice: _ctx.invoiceToPay,
          onClose: _ctx.closeInvoicePaymentModal
        }, null, 8, ["invoice", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}